import React, { ReactNode } from 'react';
import { ThemeProvider } from '../../theme/styled-components';
import theme from '../../theme/theme';

export default ({ children }: { children: ReactNode }) => (
  <ThemeProvider theme={theme as any}>{children}</ThemeProvider>
);
